import Header from './layout/Header'
import Footer from './layout/Footer'
import { Toaster } from './ui/toaster'
import CookieConsent from './CookieConsent'

export default function Layout({ children }: { children: React.ReactNode }) {
  return (
    <div className="flex min-h-screen flex-col relative">
      <div className="absolute top-0 left-0 w-full h-full bg-gradient-to-br from-violet-500/10 via-blue-500/10 to-pink-500/10 opacity-50 blur-3xl pointer-events-none -z-10 animate-pulse-slow"></div>
      <Header />
      <main className="flex-grow">{children}</main>
      <Footer />
      <Toaster />
      <CookieConsent />
    </div>
  )
}